import React from 'react'
import * as styles from './index.module.scss'
import ProductItem from '../ProductItem'

const Brand = ({ data = {} }) => {
  const { name, images, recommendProducts = [], descriptions, nameCN } = data || {}

  return (
    <div className={styles.brand}>
      <div className={styles.header}>
        <img src={images?.[0]?.full?.url} alt="merchant logo" />
        <div className={styles.info}>
          <div>
            <div className={styles.name}>{ name }</div>
          </div>
          <div className={styles.specialties}>
            { nameCN }
          </div>
        </div>
      </div>
      <div className={styles.descriptions}>
        { descriptions }
      </div>
      <div className={styles.productList}>
        {
          recommendProducts?.slice(0, 16)?.map?.(item => (
            <ProductItem
              key={item.id}
              product={item}
              name={name}
            />
          ))
        }
      </div>
    </div>
  )
}

export default Brand